import { render, staticRenderFns } from "./StagingDetails.vue?vue&type=template&id=5a05a8e0"
import script from "./StagingDetails.vue?vue&type=script&lang=js"
export * from "./StagingDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports